<mat-progress-bar *ngIf="loading" mode="query" class="my-color" mode="query" value="value" [bufferValue]="bufferValue">
</mat-progress-bar>
<div class="p-12">
  <div class="example-container mat-elevation-z8">
    <div class="table-header" *ngIf="mode == 'review'">
      <mat-form-field style="padding: 10px 20px 0px;">
        <input matInput type="text" [(ngModel)]="inputValue" (keyup)="applyFilter($event.target.value)" placeholder="Search">
        <mat-icon matPrefix>search</mat-icon>
        <mat-icon *ngIf="inputValue.length > 1" matSuffix (click)="inputValue=''" style="cursor: pointer;">close</mat-icon>
      </mat-form-field>
    </div>
    <mat-table #table [dataSource]="dataSource">
      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef> Cases </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="mobile-label">Cases:</span>
          <a href="javascript:void(0)" class="nohover" color="accent"
            (click)="openCase(element)">{{getCaseNumber(element.id)}}</a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="form">
        <mat-header-cell *matHeaderCellDef> Form </mat-header-cell>
        <mat-cell *matCellDef="let element"> <span class="mobile-label">Form:</span> {{currentForm(element.form)}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef class="description-flex">
          Description
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="description-flex">
          <span class="mobile-label">Description:</span>
          {{getFromDescription(currentForm(element.form)) }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef class="status-date-flex"> Status </mat-header-cell>
        <mat-cell *matCellDef="let element" class="status-date-flex">
          <span class="mobile-label">Status:</span>
          {{getStatusText(element)}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="submitDate">
        <mat-header-cell *matHeaderCellDef class="status-date-flex"> Creation Date </mat-header-cell>
        <mat-cell *matCellDef="let element" class="status-date-flex">
          <span class="mobile-label">Creation Date:</span>
          {{element.submitDate | date}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="modifiedDate">
        <mat-header-cell *matHeaderCellDef class="status-date-flex"> Modified Date </mat-header-cell>
        <mat-cell *matCellDef="let element" class="status-date-flex">
          <span class="mobile-label">Modified Date:</span>
          {{element.modifyDate | date}} </mat-cell>
      </ng-container>
      
      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef> Action </mat-header-cell>
        <mat-cell *matCellDef="let element" style="text-transform: uppercase;">
          <span class="mobile-label">Action:</span>
          <a *ngIf="getButtonText(element) != 'NULL'" mat-raised-button color="accent" (click)="caseAction(element)">
            <!-- <a  mat-raised-button color="accent" (click)="caseAction(element)"> -->
            {{ getButtonText(element) }}
          </a>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
    <mat-paginator #paginator [pageSize]="10" [pageSizeOptions]="[10, 30, 50]" [showFirstLastButtons]="true">
    </mat-paginator>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/content/caseList/caseList.component.html